import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { WorkforceSource } from 'api/services/workforce/workforce-service.dto';
import { useInfiniteQuery } from 'react-query';

export const useGetWorkforce = (workforceSource: WorkforceSource) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.workforceBySource(workforceSource),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedWorkforceService.getEmployees({
        pageParam,
        labourEngagementStates:
          workforceSource === 'own' ? ['approved', 'pending', 'rejected'] : undefined,
        workforceSource,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
